import http from "./http"
import HelperService from "../services/helper"
import { UpdateTeamDTO, Team, TeamSingle } from "../models/team"
import { Pagination, QueryParams } from "../models/misc"

class TeamService {
  private readonly baseUrl = "/team"

  async getTeams(filterObj?: QueryParams) {
    const queryString = HelperService.buildSearchQueryString(filterObj)
    const { data } = await http.get<Pagination<Team>>(`${this.baseUrl}/${queryString}`)
    return data
  }

  async getTeamById(id: string) {
    const { data } = await http.get<TeamSingle>(`${this.baseUrl}/${id}`)
    return data
  }

  async updateTeam(id: string, dto: UpdateTeamDTO) {
    await http.put<Team>(`${this.baseUrl}/${id}`, dto)
  }

  // Team Player
  async releasePlayer(teamId: string, userId: string) {
    await http.delete(`${this.baseUrl}/${teamId}/user/${userId}`)
  }
}

export default new TeamService()
